<template>
    <el-select
        class="w-100"
        v-model="shippingTypeLabel"
        placeholder="Seleccione tipo de envío"
        @change="notifyChange">
        <el-option
            v-for="option in shippingTypesOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value">
        </el-option>
    </el-select>
</template>

<script>
    import {shippingTypes} from '../../constants/cake-constants';

    export default {
        name: "ShippingTypeSelector",
        props: {
            value: String,
            pickup: Boolean,
        },
        data() {
            return {
                shippingTypeLabel: null
            }
        },
        created() {
            this.shippingTypeLabel = this.evaluateValue(this.value);
        },
        computed: {
            shippingTypesOptions() {
                return Object.keys(shippingTypes).map((key) => {
                    return {
                        value: key,
                        label: shippingTypes[key]
                    };
                }).filter((e) => this.pickup || e.value !== 'IN_SHOP');
            }
        },
        methods: {
            evaluateValue(value) {
                if (value) {
                    let shippingType = this.findShippingTypeByValue(value);
                    return shippingType ? shippingType.label : null;
                } else {
                    return null;
                }
            },
            findShippingTypeByValue(value) {
                return this.shippingTypesOptions.find(option => (option.value === value));
            },
            notifyChange(shippingType) {
                this.$emit('input', shippingType);
            }
        },
        watch: {
            value: function () {
                this.shippingTypeLabel = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>
